import { render } from "./BadgeStateFormatter.vue?vue&type=template&id=5313d6ee"
import script from "./BadgeStateFormatter.vue?vue&type=script&lang=js"
export * from "./BadgeStateFormatter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__